import gsap from 'gsap'

import {
  fadeRevealAnimation,
  getScrollTriggerOptions,
  linesRevealAnimation,
  type SharedAnimation
} from '@/components/sections/animations/shared'

import { Animation } from '@/types'

export const mediaCenterRevealAnimation = ({
  node,
  context,
  reverse,
  delay = 0
}: Animation) => {
  const selector = context?.selector || gsap.utils.selector(node)

  const pretitle = selector('[data-motion-pretitle]')[0]
  const title = selector('[data-motion-title]')[0]
  const text = selector('[data-motion-text]')[0]
  const items = selector('[data-motion-item]')
  const cta = selector('[data-motion-cta]')[0]

  const timeline = gsap.timeline({
    ...getScrollTriggerOptions(node, reverse),
    delay
  })

  let pretitleAnimation: SharedAnimation
  if (pretitle) {
    pretitleAnimation = linesRevealAnimation(pretitle, reverse)
    timeline.add(pretitleAnimation.timeline, 0)
  }

  let titleAnimation: SharedAnimation
  if (title) {
    titleAnimation = linesRevealAnimation(title, reverse)
    timeline.add(titleAnimation.timeline, 0.1)
  }

  let textAnimation: SharedAnimation
  if (text) {
    textAnimation = linesRevealAnimation(text, reverse)
    timeline.add(textAnimation.timeline, 0.2)
  }

  let itemsAnimation: SharedAnimation
  if (items.length) {
    itemsAnimation = {
      timeline: gsap
        .timeline()
        .fromTo(
          items,
          { opacity: 0, y: 30 },
          {
            opacity: 1,
            y: 0,
            duration: 0.8,
            ease: 'power2.out',
            stagger: 0.08
          }
        ),
      revert: () => {
        return
      }
    }
    timeline.add(itemsAnimation.timeline, 0.3)
  }

  let ctaAnimation: SharedAnimation
  if (cta) {
    ctaAnimation = fadeRevealAnimation(cta)
    timeline.add(ctaAnimation.timeline, 0.5)
  }

  return () => {
    timeline.scrollTrigger?.kill()
    timeline.kill()

    pretitleAnimation?.revert()
    titleAnimation?.revert()
    textAnimation?.revert()
    itemsAnimation?.revert()
    ctaAnimation?.revert()
  }
}
